import { render, staticRenderFns } from "./TurnProductivityCalibrator.vue?vue&type=template&id=319545c5"
import script from "./TurnProductivityCalibrator.vue?vue&type=script&lang=js"
export * from "./TurnProductivityCalibrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports